import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_BerthListComponent from "../components/_FM_berth/_FM_BerthListComponent";
import _FM_BerthFormComponent from "../components/_FM_berth/_FM_BerthFormComponent";
import _FM_BerthShowComponent from "../components/_FM_berth/_FM_BerthShowComponent";
import _FM_UnitFormComponent from "../components/_FM_unit/_FM_UnitFormComponent";
import _FM_AccommodationImportFormComponent from "../components/_FM_accommodation/_FM_AccommodationImportFormComponent";
import HelpComponent from "../components/HelpComponent";
import {Dialog} from "primereact/dialog";
import {Message} from "primereact/message";

const _FM_BerthPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();

  useEffect(() => {
    document.title = t('berths') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/berth')
  }, []);

  return (
    <div className="_FM_BerthPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/berth"}/>
      <Panel>
        <_FM_BerthListComponent />
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_BerthFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_BerthShowComponent />
      </Sidebar>


      <Dialog visible={window.App.urlVars().update === 'unit'}
              header={t('unit')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info" text={t("dialog_movable")} /></React.Fragment>}
              onHide={() => {
                navigate(-1);
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_UnitFormComponent />
      </Dialog>
      <Dialog visible={window.App.urlVars().import === 'accommodation'}
              header={t('accommodation')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info" text={t("dialog_movable")} /></React.Fragment>}
              onHide={() => {
                navigate(-1);
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_AccommodationImportFormComponent />
      </Dialog>

    </div>
  )
}
export default withTranslation('common')(_FM_BerthPage);
